import { confirmable } from 'react-confirm';
import StackedModal from './stacked_modal';
import { useTranslation } from 'react-i18next';

function DeleteDialog({ show, proceed, title, content, confirmText }) {
  const { t } = useTranslation();
  return (
    <StackedModal
      isOpen={show}
      title={title || t('common:button.delete')}
      content={content || t('common:confirmation.delete')}
      primaryAction={{
        content: confirmText || t('common:button.confirm'),
        tone: 'critical',
        onAction: () => {
          proceed(true);
        },
      }}
      onClose={() => {
        proceed(false);
      }}
    />
  );
}

export default confirmable(DeleteDialog);
